import React from 'react';
import classNames from 'classnames';
import './event-log-page.scss';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import CustomButton from '../../../components/base/Button/CustomButton';
import { Icons } from '../../../components/base/BootstrapComponents';
import { copyText } from '../../../utils/utils';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import TextAreaWithLabel from '../../../components/fields/TextInput/TextAreaWithLabel';
import { eventLogColumns } from '../constants';
import {
  statusNotificationFormatter,
  dateTimeFormatter,
  readableEventDescription,
} from '../../../utils/formatters';

const hasValue = value => value !== null && typeof value !== 'undefined' && String(value).trim() !== '';

export default function EventLogPopUp(props) {
  const { onHide, selectedItem } = props;
  const description = readableEventDescription(selectedItem.description);
  const contextFields = [
    {
      name: 'created_at',
      labelKey: 'elp.date',
      value: dateTimeFormatter(selectedItem.created_at),
      className: 'middle',
      always: true,
    },
    {
      name: 'host',
      labelKey: 'elp.hostName',
      value: selectedItem.host_name,
      className: 'middle',
    },
    {
      name: 'client_id',
      labelKey: 'elp.client_id',
      value: selectedItem.client_id,
    },
    {
      name: 'ticket',
      labelKey: 'elp.couponNumber',
      value: selectedItem.session_ticket_number,
    },
    {
      name: 'session',
      labelKey: 'elp.sessionNumber',
      value: selectedItem.session_id,
    },
  ].filter(field => field.always || hasValue(field.value));

  return (
    <Dialog
      className={classNames('elp-popup')}
      onClose={() => { onHide(); }}
      size="xl"
      open
    >
      <DialogTitle
        className="hff-title"
        title={(
          <>
            {/* Требуются уточнить у дизайнера */}
            <div className="hff-title-text f2">Информация о событии</div>
            {selectedItem.error_level ? statusNotificationFormatter(selectedItem.error_level) : null}
            <div className="hff-close-wrapper">
              <Icons width={14} height={14} customIcon icon="clear" className="hff-close" onClick={onHide} />
            </div>
          </>
        )}
      />
      <DialogContent className="hff-content custom-scroll-theme">
        {contextFields.map(field => (
          <FieldWithAttributeDTO
            key={field.name}
            type="text"
            disabled
            className={field.className}
            component={TextInputWithLabel}
            dtoObject={{
              name: field.name,
              type: String,
              validators: [],
              labelKey: field.labelKey,
            }}
            inputProps={{
              value: field.value,
            }}
          />
        ))}
        <FieldWithAttributeDTO
          type="text"
          disabled
          disabledResize
          component={TextAreaWithLabel}
          dtoObject={{
            name: 'description',
            type: String,
            validators: [],
            labelKey: 'elp.event',
          }}
          inputProps={{
            value: description,
          }}
        />
      </DialogContent>
      <DialogFooter className="hff-footer">
        <CustomButton text="Копировать" onClick={() => copyText(selectedItem, eventLogColumns)} />
        <CustomButton isCancel text="Закрыть" onClick={() => { onHide(); }} />
      </DialogFooter>
    </Dialog>
  );
}
